import { render, staticRenderFns } from "./EducationFields.vue?vue&type=template&id=a5518006&scoped=true"
import script from "./EducationFields.vue?vue&type=script&lang=js"
export * from "./EducationFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5518006",
  null
  
)

export default component.exports